import {useState} from 'react';
import DashboardFilters from 'views/dashboard/components/DashboardFilters.component';
import CampaignsStatistics from 'views/dashboard/components/CampaignsStatistics.component';
import CampaignsMassiveFileDownloadButton from 'views/dashboard/components/CampaignsMassiveFileDownloadButton.component';

export default function CampaignsDashboard() {
  const [filters, setFilters] = useState(null);

  const handleFiltersChange = (event) => {
    setFilters(event);
  };

  const elements = {
    downloadButton: (
      <CampaignsMassiveFileDownloadButton
        loading={filters === null}
        linesId={filters?.lines?.map((line) => line.id)}
        period={filters?.period}
      />
    )
  };

  return (
    <>
      <DashboardFilters 
        title='Estadísticas de campañas'
        onChange={handleFiltersChange}
        rightComponent={elements.downloadButton}
      />
      {
        (filters) &&
        <CampaignsStatistics filters={filters}/>
      }
    </>
  );
}
